<script>import { attrValue } from "../../utils/html";
export let classNames = "";
</script>

<div
	class={attrValue([
		'overflow-x-auto snap-x scroll-smooth -ml-3 -mr-3 px-3 lg:ml-0 lg:mr-0 lg:px-0 lg:overflow-x-visible',
		classNames
	])}
>
	<slot />
</div>

<style>div>:global(*){scroll-snap-align:center;scroll-snap-stop:always}</style>
